import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const projectItemApi = {
    getProjectItemsByProjectId: (projectId: number): Observable<Dtos.GetProjectItemsByProjectIdResponse> => {
        //Create the request.
        let request: Dtos.GetProjectItemsByProjectId = new Dtos.GetProjectItemsByProjectId();

        request.projectId = projectId;

        //Send request.
        const response: Promise<Dtos.GetProjectItemsByProjectIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setProjectItem: (projectItem: Dtos.ProjectItem, _collection: Dtos.Collection): Observable<Dtos.SetProjectItemResponse> => {
        let request: Dtos.SetProjectItem = new Dtos.SetProjectItem();

        request.projectItem = projectItem;
        // request.collection = collection;

        // send request
        const response: Promise<Dtos.SetProjectItemResponse> = client.post(request);

        return Observable.from(response);

    },
    createProjectItem: (projectId: number): Observable<Dtos.CreateProjectItemResponse> => {
        //Create the request.
        let request: Dtos.CreateProjectItem = new Dtos.CreateProjectItem();

        request.projectId = projectId;

        //Send request.
        const response: Promise<Dtos.CreateProjectItemResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    }
}